import router from "@/router";
import { DirectiveBinding } from "vue";
/**
 * usage1: v-permission="['string']"
 *         有string的权限即可显示
 * usage2: v-permission="['string1', 'string2]"
 *         有string1或string2的权限皆可显示
 * usage3: v-permission.all="['string1', 'string2]"  有string1或string2的权限皆可
 *         同时有string1和string2的权限才显示
 */
export default {
  mounted(el: Element, bingding: DirectiveBinding) {
    const currentRoute = router.currentRoute.value;
    const userPermissions = currentRoute.meta?.permissions as string[];
    const { value, modifiers } = bingding;
    const size = value.length;

    let hasPermission = false;
    let count = 0;

    userPermissions.forEach((p) => {
      if (value.includes(p)) count++;
    });

    if (modifiers.all) {
      // && 逻辑
      hasPermission = count === size ? true : false;
    } else {
      // || 逻辑
      hasPermission = count > 0 ? true : false;
    }

    if (!hasPermission) el.parentNode?.removeChild(el);
  },
};
